/**
 * Deletes a cookie using the CookieStore API.
 * Fallback to overriding the cookie on the document if CookieStore is not available.
 */
export const deleteCookie = async (name: string, path: string) => {
  if ('cookieStore' in window) {
    const { cookieStore } = window as { cookieStore: CookieStore };

    return cookieStore.delete(name, { path });
  }

  // eslint-disable-next-line functional/immutable-data, unicorn/no-document-cookie
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
};

type CookieStore = {
  delete(name: string, options?: CookieDeleteOptions): Promise<void>;
};

type CookieDeleteOptions = {
  path?: string;
};
